import {
  AccessFunctionFormData,
  AccessFunctionInterfaceFormData,
  AccessFunctionInterfaceFormSectionType,
} from 'data/accessFunction/accessFunction.types';
import { FormTemplate } from 'data/template/template.types';

export function handleRolePriorityFieldUpdate(
  template: FormTemplate | undefined,
  interfaceName: AccessFunctionInterfaceFormSectionType,
  fieldName: keyof AccessFunctionInterfaceFormData,
  clonedData: Partial<AccessFunctionFormData>,
  fieldValue: unknown,
  tabIndex?: number,
): Partial<AccessFunctionFormData> {

  if (template?.key !== 'PCRFIPQ' || interfaceName !== 'provisioningInterfaces' || fieldName !== 'rolepriority') {
    return clonedData;
  }

  if (clonedData.provisioningInterfaces?.length === 1) {
    template.formId = Date.now().toString();

    clonedData.provisioningInterfaces[0].rolepriority = 'PRIMARY';
    return clonedData;
  }

  if (clonedData.provisioningInterfaces?.length === 2) {
    template.formId = Date.now().toString();

    if ((tabIndex === 0 && fieldValue === 'PRIMARY') || (tabIndex === 1 && fieldValue === 'SECONDARY')) {
      clonedData.provisioningInterfaces[0].rolepriority = 'PRIMARY';
      clonedData.provisioningInterfaces[1].rolepriority = 'SECONDARY';
    } else if ((tabIndex === 1 && fieldValue === 'PRIMARY') || (tabIndex === 0 && fieldValue === 'SECONDARY')) {
      clonedData.provisioningInterfaces[0].rolepriority = 'SECONDARY';
      clonedData.provisioningInterfaces[1].rolepriority = 'PRIMARY';
    }
  }

  return clonedData;
}

export default handleRolePriorityFieldUpdate;
